import type { SearchOrListParams } from '@/utils/api/membership-service/models/search-or-list-params'

interface BuildTrainingNeedsParamsArgs {
  pageIndex: number
  pageSize: number
  organisationName?: string
  topic?: string
  dateFrom?: string
  dateTo?: string
  isAdmin: boolean
  isOrganisationAdmin: boolean
}

export function buildTrainingNeedsParams({
  pageIndex,
  pageSize,
  organisationName,
  topic,
  dateFrom,
  dateTo,
  isAdmin,
  isOrganisationAdmin,
}: BuildTrainingNeedsParamsArgs): SearchOrListParams | undefined {
  if (!isAdmin && !isOrganisationAdmin) {
    return undefined
  }

  const params: SearchOrListParams = {
    page: pageIndex,
    size: pageSize,
    sort: 'createdAt,desc',
  }

  if (organisationName?.trim()) {
    params.org = organisationName.trim()
  }

  if (isAdmin && topic?.trim()) {
    params.q = topic.trim()
  }

  if (dateFrom) {
    params.from = dateFrom
  }

  if (dateTo) {
    params.to = dateTo
  }

  return params
}

export type DateRangePreset = '30d' | '90d' | '6m' | 'ytd' | 'custom'

export function getDateRangeBounds(preset: DateRangePreset): { from: string; to: string } {
  const today = new Date()
  const to = today.toISOString().slice(0, 10)
  const fromDate = new Date(today)

  switch (preset) {
    case '30d':
      fromDate.setDate(today.getDate() - 30)
      break
    case '90d':
      fromDate.setDate(today.getDate() - 90)
      break
    case '6m':
      fromDate.setMonth(today.getMonth() - 6)
      break
    case 'ytd':
      fromDate.setMonth(0, 1)
      break
    default:
      fromDate.setMonth(today.getMonth() - 1)
  }

  const from = fromDate.toISOString().slice(0, 10)
  return { from, to }
}
